export default __webpack_public_path__ + "static/media/p2p-sg-girl.66248e21.webp";